import { useLocation, useParams } from "react-router-dom";
import { CommentDeleteRender, useGetFeedWebByFeedId } from "./model";
import { TopBar } from "../../widgets";
import { Button, Divider, Flex, Input, Modal } from "antd";
import { ReactComponent as More } from "../../assets/images/icon/more.svg";
import { ReactComponent as FillOff } from "../../assets/images/icon/fill=off.svg";
import { ReactComponent as FillOn } from "../../assets/images/icon/fill=on.svg";
import { ReactComponent as Bubble } from "../../assets/images/icon/bubble.svg";
import { ReactComponent as Warning } from "../../assets/images/icon/warning.svg";
import { ReactComponent as EyeDisable } from "../../assets/images/icon/eye-disable.svg";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { FeedClaimBottomSheet } from "../community/ui/feedClaimBottomSheet";
import {
  useCreateFeedCommentLikeWeb,
  useCreateFeedCommentWeb,
  useCreateFeedLikeWeb,
  useDeleteFeedCommentLikeWeb,
  useDeleteFeedLikeWeb,
  useUpdateFeedCommentWeb,
} from "../community/ui/recommendFeed/model";
import { useQueryClient } from "@tanstack/react-query";
import { MyCommentBottomSheet } from "../community/ui/myCommentBottomSheet";
import { TextAreaRef } from "antd/es/input/TextArea";
import { CourseBadge, CustomToast } from "../../shared";
import { androidOnInputFocus, formatRelativeDate } from "../../utils";
import MyFeedBottomSheet from "../community/ui/myFeedBottomSheet";
import { isIOS } from "react-device-detect";
import Lottie from "lottie-react";
import LoadingV2 from "../../assets/images/lottie/loadingV2.json";
import CommunityLike from "../../assets/images/lottie/coummunity_like.json";
import CommunityDetailSkeleton from "../../components/skeleton/community/detail";
import dayjs from "dayjs";
import { useDeleteFeedCommentWeb } from "../community/model";
import ConfirmModal from "../../shared/modal/confirmModal";
import { NotMyfeedAndCommentBottomSheet } from "../community/ui/notMyfeedAndCommentBottomSheet";
import { useMyContext } from "../../entities/context";
import { ReactComponent as Close } from "../../assets/images/icon/close.svg";

const CommunityFeedDetail = () => {
  const queryClient = useQueryClient();
  const inputState = new URLSearchParams(useLocation().search).get(
    "inputState"
  );
  const id = Number(useParams().id);
  const {
    data: feedDetail,
    isLoading,
    isSuccess,
    isFetching,
    isError,
    refetch,
  } = useGetFeedWebByFeedId(
    id,
    "id memberId requestMemberId nickName isBadgeShow isShow isHiddenByClaim hiddenReason content imageUrlList lastUpdatedDate createdDate feedCommentList { id content memberId isHiddenByClaim hiddenReason createdDate feedCommentLikeList { id memberId } nickName { nickName } } feedLikeList { id memberId lastUpdatedDate }"
  );
  const { topHeight } = useMyContext();
  const [isOpenFeedClaimModal, setIsOpenFeedClaimModal] = useState<boolean>();
  const [selectedFeedComment, setSelectedFeedComment] =
    useState<IFeedCommentWebResponseGraphQl>();
  const [isOpenMyCommentModal, setIsOpenMyCommentModal] =
    useState<boolean>(false);
  const [commentInput, setCommentInput] = useState<string>("");
  const [isFeedClaim, setIsFeedClaim] = useState<boolean>(false);
  const [isShowBottomSheet, setIsShowBottomSheet] = useState<boolean>(false);
  const [isLikeAnimationEnd, setIsLikeAnimationEnd] = useState<boolean>(true);
  const [isFeedCommentLikeAnimationEnd, setIsFeedCommentLikeAnimationEnd] =
    useState<boolean>(true);
  const [isCommentCreate, setIsCommentCreate] = useState<boolean>(true);
  const [isCommentUpdate, setIsCommentUpdate] = useState<boolean>(false);
  const { isInputComment } = useLocation()?.state || {};
  const commentInputRef = useRef<TextAreaRef>(null);
  const [isCommentDeleteOpen, setIsCommentDeleteOpen] =
    useState<boolean>(false);
  const [notMyBottomSheetOpen, setNotMyBottomSheetOpen] =
    useState<boolean>(false);
  const [isShowToast, setIsShowToast] = useState<boolean>(false);
  const createFeedLikeWeb = useCreateFeedLikeWeb();
  const deleteFeedLikeWeb = useDeleteFeedLikeWeb();
  const createFeedCommentWeb = useCreateFeedCommentWeb();
  const updateFeedCommentWeb = useUpdateFeedCommentWeb();
  const deleteFeedCommentWeb = useDeleteFeedCommentWeb();
  const createFeedCommentLikeWeb = useCreateFeedCommentLikeWeb();
  const deleteFeedCommentLikeWeb = useDeleteFeedCommentLikeWeb();
  const inputCommentMaxLenghtOver = (
    <div className="body/b2 base/white">
      최대 200자까지 작성하실 수 있습니다.
    </div>
  );
  const [toastText, setToastText] = useState<React.ReactNode | string>(
    CommentDeleteRender
  );
  const [isCreateFeedCommentAnimation, setIsCreateFeedCommentAnimation] =
    useState<boolean>(false);
  const [createdFeedCommentId, setCreatedFeedCommentId] = useState<number>();
  const [isMyFeedBottomSheetToast, setIsMyFeedBottomSheetToast] =
    useState<boolean>();
  const [clickFeedCommentIdByLike, setClickFeedCommentIdByLike] =
    useState<number>();

  const [imageModalOpen, setImageModalOpen] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const [touchStartX, setTouchStartX] = useState<number | null>(null);
  const [touchEndX, setTouchEndX] = useState<number | null>(null);

  const [touchStartY, setTouchStartY] = useState<number | null>(null);
  const [touchEndY, setTouchEndY] = useState<number | null>(null);

  const currentImage = feedDetail?.imageUrlList[selectedIndex];

  const getMyFeedFromFeedDetail = (): IGetMyFeedWebResponse | undefined => {
    if (!feedDetail) return;
    const myFeed: IGetMyFeedWebResponse = {
      id: id,
      nickName: feedDetail.nickName,
      content: feedDetail.content,
      imageUrlList: feedDetail.imageUrlList,
      feedLikeCnt: feedDetail.feedLikeList.length,
      feedCommentCnt: feedDetail.feedCommentList.length,
      lastUpdatedDate: feedDetail.lastUpdatedDate,
      createdDate: feedDetail.createdDate,
      isCreatedLike: feedDetail.feedLikeList.some(
        (feedLike) => feedLike.memberId === feedDetail.requestMemberId
      ),
      isShow: feedDetail.isShow,
      isPrivate: feedDetail.isPrivate,
      isBadgeShow: feedDetail.isBadgeShow,
      isHiddenByClaim: feedDetail.isHiddenByClaim,
    };

    return myFeed;
  };

  const onClickMyComnentOption = (clickId: number) => {
    if (clickId === 1) {
      setCommentInput(
        feedDetail?.feedCommentList.find(
          (q) => q.id === selectedFeedComment?.id
        )?.content ?? ""
      );
      setIsOpenMyCommentModal(false);
      setIsCommentCreate(false);

      commentInputRef.current?.focus();
    } else if (clickId === 2) {
      setIsCommentDeleteOpen(true);
      setIsOpenMyCommentModal(false);
    }
  };

  const onCommentDeleteClick = () => {
    if (!selectedFeedComment) return;
    setIsCommentDeleteOpen(false);
    deleteFeedCommentWeb.mutate(selectedFeedComment.id, {
      onSuccess: () => {
        setIsCommentCreate(true);
        setCommentInput("");
        queryClient.invalidateQueries({ queryKey: ["feedWebByFeedId", id] });
        setToastText(CommentDeleteRender);
        setIsShowToast(true);
      },
    });
  };

  useEffect(() => {
    if (!commentInputRef.current) return;
    if (isInputComment) {
      commentInputRef.current.focus();
    }
  }, [isInputComment, isSuccess]);

  useLayoutEffect(() => {
    if (inputState === "focus") {
      setTimeout(() => {
        commentInputRef.current?.focus();
      }, 1000);
    }
  }, [inputState]);

  useEffect(() => {
    if (isCreateFeedCommentAnimation) {
      setTimeout(() => {
        setIsCreateFeedCommentAnimation(false);
      }, 500);
    }
  }, [isCreateFeedCommentAnimation]);

  useEffect(() => {
    setTimeout(() => {
      setIsCommentUpdate(!isCommentCreate);
    }, 200);
  }, [isCommentCreate]);

  if (isLoading) {
    return <CommunityDetailSkeleton />;
  }

  if (isError || !feedDetail) {
    return <div>Error loading feed.</div>;
  }

  return (
    <>
      <TopBar title="게시글" rightIcon={false} thema="dark" />
      <div
        style={{
          padding: "20px",
          backgroundColor:
            feedDetail.isHiddenByClaim === true ? "var(--secondarys100)" : "",
        }}
      >
        {feedDetail.isHiddenByClaim === true && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <div style={{ display: "flex", gap: "4px" }}>
              <Warning width={16} height={16} fill="var(--errore500)" />
              <div>
                <div
                  className="caption/c1 error/e600"
                  style={{ marginBottom: "2px" }}
                >
                  운영정책 위반으로 숨김 처리된 게시글입니다.
                </div>
                <div className="body/b1 secondary/s800">
                  이유: {feedDetail.hiddenReason}
                </div>
              </div>
            </div>
            <More
              fill="var(--secondarys400)"
              onClick={() => {
                if (feedDetail.requestMemberId === feedDetail.memberId) {
                  setIsShowBottomSheet(true);
                } else {
                  setIsFeedClaim(true);
                  setNotMyBottomSheetOpen(true);
                }
              }}
            />
          </div>
        )}
        <Flex justify="space-between" style={{ marginBottom: "8px" }}>
          <Flex style={{ alignItems: "center" }} gap={8}>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <div className="sub-title/st2">{feedDetail.nickName}</div>
              {feedDetail.isBadgeShow && (
                <CourseBadge
                  style={{
                    width: "auto",
                    color: "var(--secondarys100)",
                    backgroundColor: "var(--secondarys800)",
                    padding: "2px 4px",
                    borderRadius: "var(--radius2)",
                  }}
                  children="Coach"
                />
              )}
            </div>
            <div className="caption/c1 secondary/s500">
              {formatRelativeDate(feedDetail.createdDate)}
            </div>
            {feedDetail.isShow === false && (
              <EyeDisable
                width={16}
                height={16}
                stroke="var(--secondarys400)"
                fill="var(--secondarys400)"
              />
            )}
          </Flex>
          {feedDetail.isHiddenByClaim !== true && (
            <More
              fill="var(--secondarys400)"
              onClick={() => {
                if (feedDetail.requestMemberId === feedDetail.memberId) {
                  setIsShowBottomSheet(true);
                } else {
                  setIsFeedClaim(true);
                  setNotMyBottomSheetOpen(true);
                }
              }}
            />
          )}
        </Flex>

        <div style={{ marginBottom: "12px" }}>
          <div
            className="body/b3 secondary/s850"
            style={{ marginBottom: 8, whiteSpace: "pre-wrap" }}
          >
            {feedDetail.content}
          </div>
          {feedDetail.imageUrlList.length === 1 ? (
            <img
              src={feedDetail.imageUrlList[0]}
              style={{
                width: "calc(100vw - 40px)",
                display: "block",
                maxWidth: "440px",
                height: "auto",
                borderRadius: 4,
                objectFit: "cover",
              }}

              onClick={() => {
                setImageModalOpen(true);
                setSelectedImage(feedDetail.imageUrlList[0])
              }}
            />
          ) : (
            <Flex style={{
              overflowX: "auto",
              paddingLeft: 0,
              paddingRight: 20,
              marginLeft: -20,
              marginRight: -20,
            }}
              gap={12}>
              {feedDetail.imageUrlList.map((imageUrl, idx) => (
                <img
                  key={idx}
                  src={imageUrl}
                  style={{ width: "auto", height: "25vh", borderRadius: 4, border: "1px solid rgba(0, 0, 0, 0.05)", marginLeft: idx === 0 ? 20 : 0, }}
                  onClick={() => {
                    setImageModalOpen(true);
                    setSelectedImage(imageUrl);
                    setSelectedIndex(idx);
                  }}
                />
              ))}
            </Flex>
          )}
        </div>
        <div>
          <Flex gap={12}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {feedDetail.feedLikeList.some(
                (feedLike) => feedLike.memberId === feedDetail.requestMemberId
              ) ? (
                isLikeAnimationEnd ? (
                  <FillOn
                    style={{ color: "var(--errore400)" }}
                    onClick={() => {
                      setIsLikeAnimationEnd(true);
                      !deleteFeedLikeWeb.isPending &&
                        deleteFeedLikeWeb.mutate(feedDetail.id, {
                          onSuccess: (res) => {
                            if (res.data) {
                              refetch();
                              queryClient.invalidateQueries({
                                predicate: (query) => {
                                  return (
                                    Array.isArray(query.queryKey) &&
                                    query.queryKey[0] === "feedList"
                                  );
                                },
                              });
                            }
                          },
                        });
                    }}
                  />
                ) : (
                  <Lottie
                    style={{
                      width: 30,
                      height: 30,
                      margin: "-5px",
                      color: "var(--errore400)",
                    }}
                    animationData={CommunityLike}
                    autoplay={true}
                    loop={false}
                    onComplete={() => {
                      setIsLikeAnimationEnd(true);
                    }}
                  />
                )
              ) : (
                <FillOff
                  onClick={() => {
                    setIsLikeAnimationEnd(false);
                    !createFeedLikeWeb.isPending &&
                      createFeedLikeWeb.mutate(feedDetail.id, {
                        onSuccess: (res) => {
                          if (res.data) {
                            refetch();
                            queryClient.invalidateQueries({
                              predicate: (query) => {
                                return (
                                  Array.isArray(query.queryKey) &&
                                  query.queryKey[0] === "feedList"
                                );
                              },
                            });
                          }
                        },
                      });
                  }}
                />
              )}
              <div className="body/b1 secondary/s500">
                {feedDetail.feedLikeList.length >= 1000
                  ? "999+"
                  : feedDetail.feedLikeList.length.toLocaleString()}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Bubble onClick={() => commentInputRef.current?.focus()} />
              <div className="body/b1 secondary/s500">
                {feedDetail.feedCommentList.length >= 1000
                  ? "999+"
                  : feedDetail.feedCommentList.length.toLocaleString()}
              </div>
            </div>
          </Flex>
        </div>
      </div>

      <Divider
        style={{
          borderBlockStart: "6px solid var(--secondarys100)",
          margin: "0",
        }}
      />
      <div
        className="sub-title/st3"
        style={{
          marginTop: "24px",
          marginBottom:
            feedDetail.feedCommentList.length === 0 ? "24px" : "12px",
          paddingInline: "20px",
        }}
      >
        댓글 ({feedDetail.feedCommentList.length})
      </div>

      {feedDetail.feedCommentList
        .sort((a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate)))
        .map((feedComment, idx, arr) => (
          <div
            key={feedComment.id}
            style={{
              position: "relative",
              opacity:
                feedComment.id === selectedFeedComment?.id &&
                  (updateFeedCommentWeb.isPending ||
                    deleteFeedCommentWeb.isPending ||
                    isFetching)
                  ? 0.3
                  : 1,
            }}
          >
            <div
              style={{
                padding: 20,
                borderBottom:
                  idx === arr.length - 1
                    ? "none"
                    : "1px solid var(--secondarys100)",
                backgroundColor:
                  feedComment.isHiddenByClaim === true
                    ? "var(--secondarys100)"
                    : "",
              }}
            >
              {feedComment.isHiddenByClaim === true && (
                <div
                  style={{ display: "flex", justifyContent: 'space-between', marginBottom: "12px" }}
                >
                  <div style={{ display: "flex", gap: "4px" }}>
                    <Warning width={16} height={16} fill="var(--errore500)" />
                    <div>
                      <div
                        className="caption/c1 error/e600"
                        style={{ marginBottom: "2px" }}
                      >
                        운영정책 위반으로 숨김 처리된 게시글입니다.
                      </div>
                      <div className="body/b1 secondary/s800">
                        이유: {feedComment.hiddenReason}
                      </div>
                    </div>
                  </div>
                  <More
                    fill="var(--secondarys400)"
                    onClick={() => {
                      setIsFeedClaim(false);
                      setSelectedFeedComment(feedComment);
                      feedComment.memberId == feedDetail.requestMemberId
                        ? setIsOpenMyCommentModal(true)
                        : setNotMyBottomSheetOpen(true);
                    }}
                  />
                </div>
              )}
              <Flex justify="space-between" style={{ marginBottom: "8px" }}>
                <Flex style={{ alignItems: "center" }} gap={8}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <div className="sub-title/st2">
                      {feedComment.nickName.nickName}
                    </div>
                  </div>
                  <div className="caption/c1 secondary/s500">
                    {formatRelativeDate(feedComment.createdDate)}
                  </div>
                </Flex>
                {feedComment.isHiddenByClaim !== true &&
                  <More
                    fill="var(--secondarys400)"
                    onClick={() => {
                      setIsFeedClaim(false);
                      setSelectedFeedComment(feedComment);
                      feedComment.memberId == feedDetail.requestMemberId
                        ? setIsOpenMyCommentModal(true)
                        : setNotMyBottomSheetOpen(true);
                    }}
                  />}
              </Flex>
              <div
                className="body/b3 secondary/s850"
                style={{ marginBottom: "12px", whiteSpace: "pre-wrap" }}
              >
                {feedComment.content}
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {feedComment.feedCommentLikeList.some(
                  (feedCommentLike) =>
                    feedCommentLike.memberId === feedDetail.requestMemberId
                ) ? (
                  isFeedCommentLikeAnimationEnd ||
                    feedComment.id !== clickFeedCommentIdByLike ? (
                    <FillOn
                      style={{ color: "var(--errore400)" }}
                      onClick={() => {
                        setIsFeedCommentLikeAnimationEnd(true);
                        !deleteFeedCommentLikeWeb.isPending &&
                          deleteFeedCommentLikeWeb.mutate(feedComment.id, {
                            onSuccess: (res) => {
                              if (res.data) {
                                refetch();
                              }
                            },
                          });
                      }}
                    />
                  ) : (
                    <Lottie
                      style={{
                        width: 30,
                        height: 30,
                        margin: "-5px",
                        color: "var(--errore400)",
                      }}
                      animationData={CommunityLike}
                      autoplay={true}
                      loop={false}
                      onComplete={() => {
                        setIsFeedCommentLikeAnimationEnd(true);
                      }}
                    />
                  )
                ) : (
                  <FillOff
                    onClick={() => {
                      setIsFeedCommentLikeAnimationEnd(false);
                      setClickFeedCommentIdByLike(feedComment.id);
                      !createFeedCommentLikeWeb.isPending &&
                        createFeedCommentLikeWeb.mutate(feedComment.id, {
                          onSuccess: (res) => {
                            if (res.data) {
                              refetch();
                            }
                          },
                        });
                    }}
                  />
                )}
                <div className="body/b1 secondary/s500">
                  {feedComment.feedCommentLikeList.length >= 1000
                    ? "999+"
                    : feedComment.feedCommentLikeList.length.toLocaleString()}
                </div>
              </div>
            </div>
            {(feedComment.id === selectedFeedComment?.id &&
              (updateFeedCommentWeb.isPending ||
                deleteFeedCommentWeb.isPending ||
                isFetching)) ||
              (createdFeedCommentId === Number(feedComment.id) &&
                isCreateFeedCommentAnimation && (
                  <>
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "100%",
                        height: "100%",
                        opacity: 0.7,
                        backgroundColor: "white",
                      }}
                    ></div>
                    <Lottie
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 60,
                        height: 60,
                        opacity: 0.7,
                      }}
                      animationData={LoadingV2}
                      autoplay={true}
                    />
                  </>
                ))}
          </div>
        ))}

      <div
        className={
          isShowToast || isMyFeedBottomSheetToast
            ? "slide-out-bottom"
            : isCommentUpdate
              ? "slide-in-bottom"
              : isCommentCreate
                ? "slide-in-bottom"
                : "slide-out-bottom"
        }
        style={{
          position: "fixed",
          bottom: 0,
          paddingBottom: isIOS ? 34 : 4,
          borderTop: "1px solid var(--secondarys100)",
          width: "100%",
          maxWidth: "480px",
          backgroundColor: "var(--basewhite)",
        }}
      >
        <div style={{ padding: "16px 20px" }}>
          <Flex gap={12} align="center">
            <Input.TextArea
              className="body/b2 base/black"
              ref={commentInputRef}
              variant="borderless"
              autoSize={{ minRows: 2, maxRows: 2 }}
              placeholder={`${feedDetail.nickName}님께 댓글 달기`}
              maxLength={201}
              style={{ padding: 0, scrollbarWidth: "thin" }}
              onChange={(e) => {
                const value = e.target.value;
                if (value.length > 200) {
                  setCommentInput(value.slice(0, 200));
                  setToastText(inputCommentMaxLenghtOver);
                  setIsShowToast(true);
                } else {
                  setCommentInput(value);
                }
              }}
              value={commentInput}
              onFocus={() => androidOnInputFocus(true)}
              onBlur={() => androidOnInputFocus(false)}
            />
            <Button
              color="default"
              variant="solid"
              disabled={commentInput === ""}
              style={{
                backgroundColor:
                  commentInput === "" ? "var(--secondarys200, #E9E9E9)" : "",
                color: commentInput === "" ? "var(--secondarys400)" : "",
                border: "none",
              }}
              onClick={() => {
                isCommentCreate
                  ? !createFeedCommentWeb.isPending &&
                  createFeedCommentWeb.mutate(
                    { feedId: id, content: commentInput },
                    {
                      onSuccess: (res) => {
                        if (res.data) {
                          refetch()
                          setCommentInput("");
                          setIsCreateFeedCommentAnimation(true);
                          setCreatedFeedCommentId(Number(res.data));
                        }
                      },
                    }
                  )
                  : !updateFeedCommentWeb.isPending &&
                  selectedFeedComment &&
                  updateFeedCommentWeb.mutate(
                    { id: selectedFeedComment?.id, content: commentInput },
                    {
                      onSuccess: (res) => {
                        if (res.data) {
                          refetch()
                          setIsCommentCreate(true);
                          setCommentInput("");
                        }
                      },
                    }
                  );
              }}
            >
              {isCommentCreate ? "게시" : "수정"}
            </Button>
          </Flex>
        </div>
      </div>
      <div style={{ height: isIOS ? "101px" : "77px" }} />
      <Modal
        classNames={{ wrapper: "custom_image_modal" }}
        centered
        open={imageModalOpen}
        styles={{
          wrapper: { backgroundColor: "var(--baseblack)" },
          content: { padding: 0 },
        }}
        onCancel={() => setImageModalOpen(false)}
        closeIcon={null}
        footer={null}
      >
        <img
          src={currentImage}
          style={{
            width: "100vw",
            display: "block",
            maxWidth: "440px",
            height: "auto",
            objectFit: "cover",
            touchAction: "none",
            transition: "transform 0.3s ease",
          }}
          onTouchStart={(e) => {
            setTouchStartX(e.touches[0].clientX);
            setTouchStartY(e.touches[0].clientY);
          }}
          onTouchMove={(e) => {
            setTouchEndX(e.touches[0].clientX);
            setTouchEndY(e.touches[0].clientY);
          }}
          onTouchEnd={() => {
            if (touchStartX !== null && touchEndX !== null) {
              const diffX = touchEndX - touchStartX;

              if (diffX < -50 && selectedIndex < feedDetail.imageUrlList.length - 1) {
                setSelectedIndex((prev) => prev + 1);
              } else if (diffX > 50 && selectedIndex > 0) {
                setSelectedIndex((prev) => prev - 1);
              }
            }

            if (touchStartY !== null && touchEndY !== null) {
              const diffY = touchEndY - touchStartY;
              if (diffY > 100) {
                setImageModalOpen(false);
              }
            }

            setTouchStartX(null);
            setTouchEndX(null);
            setTouchStartY(null);
            setTouchEndY(null);
          }}
        />
      </Modal>
      {imageModalOpen && (
        <Close
          width={24}
          height={24}
          stroke="var(--basewhite)"
          style={{
            position: "fixed",
            top: topHeight ?? 16,
            left: 16,
            zIndex: 1003,
            padding: "12px",
            cursor: "pointer",
          }}
          onClick={() => setImageModalOpen(false)}
        />
      )}
      <NotMyfeedAndCommentBottomSheet
        isOpen={notMyBottomSheetOpen}
        setIsOpen={setNotMyBottomSheetOpen}
        onClick={(q: number) => q === 1 && setIsOpenFeedClaimModal(true)}
      />
      <FeedClaimBottomSheet
        feedId={id}
        feedCommentId={selectedFeedComment?.id}
        isFeedClaim={isFeedClaim}
        isOpen={isOpenFeedClaimModal ?? false}
        setIsOpen={setIsOpenFeedClaimModal}
        onToastChange={setIsMyFeedBottomSheetToast}
        styles={{ toast: { bottom: isIOS ? 34 : 20 } }}
      />
      {selectedFeedComment && (
        <MyCommentBottomSheet
          feedId={feedDetail.id}
          feedComment={selectedFeedComment}
          isOpen={isOpenMyCommentModal}
          setIsOpen={setIsOpenMyCommentModal}
          onClick={onClickMyComnentOption}
        />
      )}
      <MyFeedBottomSheet
        selectedFeed={getMyFeedFromFeedDetail()}
        isShowBottomSheet={isShowBottomSheet}
        setIsShowBottomSheet={setIsShowBottomSheet}
        onToastChange={setIsMyFeedBottomSheetToast}
        styles={{ toast: { bottom: isIOS ? 34 : 20 } }}
      />
      <ConfirmModal
        open={isCommentDeleteOpen}
        setOpen={setIsCommentDeleteOpen}
        title="댓글 삭제"
        content="작성한 댓글을 삭제하시겠습니까?"
        cancelBtn="돌아가기"
        okBtn="댓글 삭제"
        modalStyles={{
          content: { padding: "20px 16px", marginInline: "23.5px" },
        }}
        classNames={{ okBtn: "sub-title/st3", cancelBtn: "sub-title/st3" }}
        onCancelClick={() => setIsCommentDeleteOpen(false)}
        onOkClick={onCommentDeleteClick}
      />
      {isShowToast && (
        <CustomToast
          duration={3000}
          setToast={setIsShowToast}
          text={toastText}
          style={{ backgroundColor: "var(--dimd300)" }}
        />
      )}
    </>
  );
};

export default CommunityFeedDetail;
